module.exports = __webpack_public_path__ + "static/media/homepage_header_mobile_english.94dd9b49.jpg";